export const paymentPeriodClosed = (payment, settings) => {
  const field = {
    ChequeClearingDate: "PyhClearDt",
    ChequeDate: "PyhChqDt",
    PaymentDate: "PyhDate",
  }[settings.SettingAp.PaymentPostingBy];
  const closeDate = settings.SettingClosePeriod.ClosePeriodAp;
  // The API also checks Payment Date regardless of the posting setting.
  return (
    !!closeDate &&
    [payment?.PyhDate, payment?.[field]].some(
      (date) => date && date <= closeDate,
    )
  );
};

export const canEditClearingDate = (payment, settings) =>
  !!payment &&
  payment.PyhStatus !== "Void" &&
  (!paymentPeriodClosed(payment, settings) || !payment.PyhClearDt);
